import React, { useEffect, useRef, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import Header from "../Sections/Header";
import Footer from "../Sections/Footer";
import { fetchPracticeInformations } from "../../APIConnections/appointments";
import { notify } from "../helpers";
import NotFound from "../pages/NotFound";

export default function Layout() {
  const { practice_slug } = useParams();
  const [practiceData, setPracticeData] = useState({});
  const [loading, setLoading] = useState(true);
  const [isValid, setIsValid] = useState(true);
  const isFetched = useRef(false);

  useEffect(() => {
    if (!isFetched.current && practice_slug) {
      fetchPracticeInfo(practice_slug);
      isFetched.current = true;
    }
  }, [practice_slug]);

  const fetchPracticeInfo = async (name) => {
    setLoading(true);
    const practiceData = {
      practice_name: name
    };
    try {
      const response = await fetchPracticeInformations(practiceData);
      if(response){
        if(response?.error) {
          notify("error", response?.error);
          setIsValid(false);
          return;
        }
        if(response?.data) {
          if(response?.data?.message) {
            notify("error", response?.data?.message);
            setIsValid(false);
            return;
          }
          setPracticeData(response?.data);
          setIsValid(true);
        } else {
          notify("error", response?.detail);
          setIsValid(false);
        }
      }
    } catch (error) {
      console.log("🚀 ~ fetchPracticeInfo ~ error:", error);
      setIsValid(false);
    } finally {
      setLoading(false);
    }
  }


  return (
    <>
      {loading ? (
        <div className="flex items-center justify-center min-h-[100vh]">Loading...</div>
      ) : (
        isValid ? (
          <div className="docpro_main">
            <div className="docpro_main_sections">
              <div>
                <Header practiceData={practiceData}/>
                <main className="container mx-auto my-8">
                  <section className="bg-white p-4 md:p-8">
                    <Outlet context={practiceData} />
                  </section>
                </main>
              </div>
              <Footer practiceData={practiceData} />
            </div>
          </div>
        ) : (
          <NotFound />
        )
      )}
    </>
  );
}
